module.exports = __webpack_public_path__ + "static/media/toto-bordered-3x.44d84a8b.png";